module.exports = __webpack_public_path__ + "static/media/logo-inverse.5d61821f.svg";